/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 912df5a8ecfa
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  TransformationInfo,
  TransformationInfo$zodSchema,
} from "./transformationinfo.js";

export type GetTransformationGlobals = { cloud_name?: string | undefined };

export const GetTransformationGlobals$zodSchema: z.ZodType<
  GetTransformationGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type GetTransformationRequest = { transformation: string };

export const GetTransformationRequest$zodSchema: z.ZodType<
  GetTransformationRequest
> = z.object({
  transformation: z.string().describe(
    "The transformation identifier. Can be either a named transformation (e.g., 'small_profile_thumbnail') or a transformation string (e.g., 'w_100,h_150,c_fill,g_auto').\n",
  ),
});

export type GetTransformationResponse = ApiError | TransformationInfo;

export const GetTransformationResponse$zodSchema: z.ZodType<
  GetTransformationResponse
> = z.union([
  ApiError$zodSchema,
  TransformationInfo$zodSchema,
]);
